'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { Languages } from 'lucide-react';

import ShaojiangDropdown from '@shaojiang/components/ShaojiangDropdown';
import { IconButton } from '@shaojiang/components/ui/icon-button';
import useLocale from '@shaojiang/hooks/useLocale';
import { defaultLocale, languages } from '@shaojiang/i18n/config';

export default function LangSwitch() {
  const { locale, pathName } = useLocale();
  const router = useRouter();

  const setLocale = (locale: string | number) => {
    router.push(`/${locale}${pathName}`);
  };

  return (
    <ShaojiangDropdown
      tooltip='Switch Language'
      menus={languages.map((lang) => ({ label: lang.name, value: lang.code }))}
      activeValue={locale || defaultLocale}
      onChange={setLocale}
    >
      <IconButton variant='ghost' colorPalette='gray' aria-label='Switch language' color='fg.icon'>
        <Languages />
      </IconButton>
    </ShaojiangDropdown>
  );
}
